// What is specific to the mobil audit (the trado one is in audit-kendaraan-trado-editor/utils).
const auditEditorConfig = {
  // title of the page
  baseTitle: "Audit",

  // a trailer is needed when there is no kendaraan (mobil: never required, so no trailer field either)
  requireTrailer: false,
  showTrailerField: false,

  // which kendaraan can be picked in the header
  kendaraanSelectorFilter: "data_kendaraan_jenis.nama:!=:Trado",
};

export default auditEditorConfig;
